export enum ElasticSearchFilterTypes {
  CONTEXT = 'context',
  TERMINOLOGY = 'terminology',
  KDS_MODULE = 'kds_module',
  AVAILABILITY = 'availability',
}
